import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import MUISelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/Lock';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import FormContext from '../FormContext';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    background: theme.palette.grey[50]
  },
  formControlRoot: {
    '& .MuiFilledInput-root.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  }
}));

const SelectField = ({
  label,
  dataField,
  items = [],
  helperText,
  disabled = false
}) => {
  const classes = useStyles();
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const value = getFieldValue(dataField);
  const selectId = `form-field/${dataField}`;

  function getEndAdornment() {
    if (disabled) {
      return (
        <InputAdornment position="end">
          <LockIcon />
        </InputAdornment>
      );
    }
    return null;
  }

  function getIconComponent() {
    return disabled ? () => <></> : ArrowDropDownIcon;
  }

  return (
    <FormControl
      margin="normal"
      fullWidth
      variant="filled"
      classes={{ root: classes.formControlRoot }}
    >
      <InputLabel htmlFor={selectId}>
        <FormattedMessage id={label} />
      </InputLabel>
      <MUISelect
        id={selectId}
        classes={{ root: classes.selectRoot }}
        value={value}
        onChange={event => {
          setFieldValue(dataField, event.target.value);
        }}
        disabled={disabled}
        endAdornment={getEndAdornment()}
        IconComponent={getIconComponent()}
      >
        <MenuItem key="select-item/$$none">
          <em>
            <FormattedMessage id="form.selectEmptyLabel" />
          </em>
        </MenuItem>
        {items.map(item => {
          return (
            <MenuItem key={`select-item/${item.value}`} value={item.value}>
              {item.label}
            </MenuItem>
          );
        })}
      </MUISelect>
      <FormHelperText>
        <FormattedMessage id={helperText} />
      </FormHelperText>
    </FormControl>
  );
};

SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  items: PropTypes.array,
  helperText: PropTypes.string
};

export default SelectField;
